import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CrossIcon } from "@/constants/utils/svgs";
import { useAppSelector } from "@/hooks/hook";
import NotificationBell from "@/components/notifications/NotificationBell";
import { BookingNotification } from "@/interfaces/Notifcations";
import { LogoutModalComp } from "@/components/modals/LogoutModalComp";
import { Button } from "@thdinc/hpf-shared";

interface User {
  first_name: string;
  last_name: string;
  roles: string;
  notificationList: BookingNotification;
}

export const MobileSideBar = ({
  accessToken,
  closeSidebar,
  logoutUser,
  notificationList,
  getNotificationsCount,
  notificationCount,
  getNotifications
}: any) => {
  const sidebarRef = useRef<HTMLDivElement | null>(null);
  const [logoutModal, setLogoutModal] = useState<boolean>(false);
  const user = useAppSelector((store) => store.user)
  // Handle closing sidebar on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        closeSidebar(); // Close sidebar if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeSidebar]);
  const canelLogoutFun = () => {
    setLogoutModal(false);
  };
  if ((!user.card || !user.application_access) && user.roles !== 'admin') {
    return (
      <div
        ref={sidebarRef}
        className="z-50 fixed right-0 top-0 bottom-0 px-5 py-5 md:w-4/12 w-6/12  bg-white"
      >
        <div className="flex justify-between items-start">
          <div onClick={closeSidebar}>
            <CrossIcon />
          </div>
          {accessToken && (
            <NotificationBell
              closeSidebar={closeSidebar}
              notificationCount={notificationCount}
              getNotificationsCount={getNotificationsCount}
              notificationList={notificationList}
              getNotifications={getNotifications}
            />
          )}
        </div>
        <div className="">
          <Button
            // onClick={() => {
            //   logoutUser();
            //   closeSidebar(); // Close sidebar when logout is clicked
            // }}
            onClick={() => setLogoutModal(true)}
            className="absolute bottom-1 left-2 text-center  inline-block px-6 bg-primary-red text-white rounded-lg py-2"
          >
            Logout
          </Button>
          <div className="h-5/6">
            <ul className=" h-full flex flex-col justify-start gap-6 text-gray-400 font-semibold">
              {user.futurePayment && <Link
                to="/events?tab=Upcoming"
                className="mr-6"
                onClick={closeSidebar}
              >
                Bookings
              </Link>}
              <Link to="/billing" className="mr-6" onClick={closeSidebar}>
                Billing
              </Link>

            </ul>
          </div>

        </div>

        {logoutModal && (
          <LogoutModalComp
            isOpen={logoutModal}
            title="Logout"
            desc="Are you sure you want to logout"
            positiveButtonText="No, Stay"
            negativeButtonText="Yes, Leave"
            handleDiscardChanges={logoutUser}
            handleSaveChanges={canelLogoutFun}
          />
        )}
      </div>
    )
  }
  return (
    <div
      ref={sidebarRef}
      className="z-50 fixed right-0 top-0 bottom-0 px-5 py-5 md:w-4/12 bg-white"
    >
      <div className="flex justify-between items-start">
        <div onClick={closeSidebar}>
          <CrossIcon />
        </div>
        {accessToken && (
          <NotificationBell
            notificationList={notificationList}
            closeSidebar={closeSidebar}
            notificationCount={notificationCount}
            getNotificationsCount={getNotificationsCount}
            getNotifications={getNotifications}
          />
        )}
      </div>
      <div className="">
        <Button
          // onClick={() => {
          //   logoutUser();
          //   closeSidebar(); // Close sidebar when logout is clicked
          // }}
          onClick={() => setLogoutModal(true)}
          className="absolute bottom-1 left-2 text-center  inline-block px-6 bg-primary-red text-white rounded-lg py-2"
        >
          Logout
        </Button>
        <div className="h-5/6">
          <ul className=" h-full flex flex-col justify-start gap-6 text-gray-400 font-semibold">
            {/* <Link to="/" className="mr-6" onClick={closeSidebar}>
            Home
          </Link> */}
            {user?.roles == "admin" && (
              <Link to="/company" className="mr-6" onClick={closeSidebar}>
                Businesses
              </Link>
            )}
            <Link to="/dashboard" className="mr-6" onClick={closeSidebar}>
              Home
            </Link>
            <Link
              to="/events?tab=Upcoming"
              className="mr-6"
              onClick={closeSidebar}
            >
              Bookings
            </Link>
            <Link
              to="/bartenders/schedule"
              className="mr-6"
              onClick={closeSidebar}
            >
              Scheduler
            </Link>
            <Link to="/" className="mr-6" onClick={closeSidebar}>
              Bartenders
            </Link>
            {user?.roles == "admin" && (
              <Link to="/payments" className="mr-6" onClick={closeSidebar}>
                Payments
              </Link>
            )}
            <Link to="/pricecalculator" className="mr-6" onClick={closeSidebar}>
            Package/PriceCalculator
            </Link>
            <Link to="/business" className="mr-6" onClick={closeSidebar}>
              Business
            </Link>
            {/* <Link to="/packages" className="mr-6" onClick={closeSidebar}>
              Packages
            </Link> */}
            <Link to="/cocktails" className="mr-6" onClick={closeSidebar}>
              Cocktails
            </Link>
            <Link to="/discount" className="mr-6" onClick={closeSidebar}>
              Discounts
            </Link>
            <Link to="/billing" className="mr-6" onClick={closeSidebar}>
              Billing
            </Link>
          </ul>
        </div>
      </div>

      {logoutModal && (
        <LogoutModalComp
          isOpen={logoutModal}
          title="Logout"
          desc="Are you sure you want to logout"
          positiveButtonText="No, Stay"
          negativeButtonText="Yes, Leave"
          handleDiscardChanges={logoutUser}
          handleSaveChanges={canelLogoutFun}
        />
      )}
    </div>
  );
};
